import React, { Component } from 'react';
import intl from 'react-intl-universal';
import { getParameterByName } from '../../querystring.js';


const locales = {
    'pt-BR': require('../../locales/pt-BR.json'),
    'en-US': require('../../locales/en-US.json'),
    'es-ES': require('../../locales/es-ES.json')
  };

class Section extends Component {

    constructor() {
        super();

        const querystring = getParameterByName('lang');

        const language = querystring ? querystring : navigator.language;
    
        const currentLocale = locales[language] ? language : 'pt-BR';
    
        intl.init({
          currentLocale,
          locales
        });
      }

    render() {
        return (
            <div className="row">
                <div className="col-md-6">
                    <div className="feature-mockup" id="feature-mockup">
                        <div id="feature-mockup-left" class="feature-mockup-left">
                            <img class="img-responsive app-tracksale" src="https://static-files.tracksale.co/npsmachine/images/app-tracksale-calculadora-nps.png" alt="Calculadora NPS | Aplicativo Tracksale"/>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="heading-text-left m-bottom-40">
                        <h2 id="setion-heading" className="section-heading">
                            {intl.get('section.whatnps')}
                        </h2>
                        <p id="lead" className="lead">
                            <p id="lead" class="lead">{intl.get('section.métrica')}</p>
                            <p id="lead" class="lead"> {intl.get('section.utilizar')}<br />
                                <b>{intl.get('section.escala')}</b> {intl.get('section.amigo')}</p>
                        </p>
                        <p id="lead">
                            <b><span style={{color:"#FF6C60"}}>{intl.get('section.detratores')}</span><br />
                            <span style={{color:"#F8D347"}}>{intl.get('section.neutros')}</span><br />
                            <span style={{color:"#5DC96C"}}>{intl.get('section.promotores')}</span></b><br /><br />
                        </p>
                        {/* <p id="lead">
                            <span style={{color:"#878787"}}>{intl.get('section.npscalculadora')}</span><br />
                            <span style={{color:"#878787"}}><span style={{color:"#5DC96C"}}>{intl.get('section.percentpromoters')}</span> - <span style={{color:"#FF6C60"}}>{intl.get('section.percentdetrators')}</span> = <span style={{color:"#3D3D3D"}}>{intl.get('section.nps')}</span></span><br />
                            <span style={{color:"#878787"}}>{intl.get('section.npsvariant')}</span>
                        </p> */}
                        <p>
                            <img src='imgs/nps.png' /> 
                        </p>
                        {/* <div className="btn-c2a">
                            <a href="https://go.tracksale.co/tracksale-faca-um-teste-gratuito" target="_blank" rel="noopener noreferrer" title="Site Tracksale">
                                <button class="btn-consultor2">{intl.get('section.botãotexto')}</button>
                            </a>
                        </div> */}
                    </div>
                </div>
            </div>

        );

    }
}

export default Section;
